import { LayerFieldInfoService } from './services/layer-field-info-service.interface';
import { FocusNodeServiceImp } from './services/focus-node-service';
import { FocusNodeService } from './services/focus-node-service.interface';
import { LayerFieldDataServiceImp } from './services/layer-field-data-service';
import { GetLayerFieldData, SetLayerFieldData } from './services/layer-field-data-service.interface';
import { LayerFieldInfoServiceImp } from './services/layer-field-info-service';
import { LayerFieldServiceImp } from './services/layer-field-service';
import { LayerFieldService } from './services/layer-field-service.interface';
import { TreeRefServiceImp } from './services/tree-ref-service';
import { TreeRefService } from './services/tree-ref-service.interface';
import { FieldEditorServiceImpl } from '@/presentation/components/field-editor';
import { FieldEditorService } from '@/presentation/components/field-editor/field-editor-service.interface';
import { LayerFieldSelectService } from './services/Layer-field-select-service.interface';
import { LayerFieldSelectServiceImp } from './services/Layer-field-select-service';
/**
 * Binds the dependencies for the layer field editor module.
 * @param bind - The binding container.
 */
export function layerFieldEditorModule(bind) {
    bind(LayerFieldInfoService).to(LayerFieldInfoServiceImp);
    bind(GetLayerFieldData).to(LayerFieldDataServiceImp);
    bind(SetLayerFieldData).to(LayerFieldDataServiceImp);
    bind(LayerFieldService).to(LayerFieldServiceImp);
    bind(LayerFieldSelectService).to(LayerFieldSelectServiceImp);
    bind(FocusNodeService).to(FocusNodeServiceImp);
    bind(TreeRefService).to(TreeRefServiceImp);
    bind(FieldEditorService).to(FieldEditorServiceImpl);
}
